import { render, staticRenderFns } from "./NewPoliceUnit.vue?vue&type=template&id=7091a358&"
import script from "./NewPoliceUnit.vue?vue&type=script&lang=js&"
export * from "./NewPoliceUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports